import type { CheckoutConfig } from '#types/config/components/checkout'

export default {
  isLoyaltyAccordionOpen: true,
  minimumLoyaltyAmount: '0',
  minimumLoyaltyPoints: 0,
  showLoyaltyPaymentAsAccordion: true,
} satisfies CheckoutConfig['paymentLoyalty']
